export default __webpack_public_path__ + "static/media/no_site_placeholder.67abfcc9.svg";